import {CApiNotification} from './CApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
export class CKickBanApiNotification {
  addPosChannelEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('Personal', 'Disconnect', fn);
  }
}
